// @ts-nocheck
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GraphicsVendorsTab from '@/components/admin/graphics/GraphicsVendorsTab';
import GraphicsAnalyticsTab from '@/components/admin/graphics/GraphicsAnalyticsTab';
import GraphicsFinanceTab from '@/components/admin/graphics/GraphicsFinanceTab';
import GraphicsPackageTypesTab from '@/components/admin/graphics/GraphicsPackageTypesTab';

const GraphicsVendorManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('vendors');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold">Graphics Vendor Management</h1>
        <p className="text-gray-600 mt-1">
          Manage graphics vendor accounts, commissions, and analytics
        </p>
      </div>

      {/* Main Content */}
      <Card>
        <CardHeader>
          <CardTitle>Graphics Vendor Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-4">
              <TabsTrigger value="vendors">Graphics Vendors</TabsTrigger>
              <TabsTrigger value="packages">Package Types</TabsTrigger>
              <TabsTrigger value="analytics">Analytics</TabsTrigger>
              <TabsTrigger value="finance">Finance</TabsTrigger>
            </TabsList>
            
            <TabsContent value="vendors" className="mt-6">
              <GraphicsVendorsTab />
            </TabsContent>
            
            <TabsContent value="packages" className="mt-6">
              <GraphicsPackageTypesTab />
            </TabsContent>
            
            <TabsContent value="analytics" className="mt-6">
              <GraphicsAnalyticsTab />
            </TabsContent>
            
            <TabsContent value="finance" className="mt-6">
              <GraphicsFinanceTab />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default GraphicsVendorManagement;